import { render, staticRenderFns } from "./article-descriptions.vue?vue&type=template&id=8609572c"
import script from "./article-descriptions.vue?vue&type=script&lang=js"
export * from "./article-descriptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports